import React, { useEffect, useState } from "react";
import { MessageCircle, Phone, UserCheck } from "lucide-react";
import api from "../lib/api";
import { logWa } from "../lib/wa";
import { useI18n } from "../i18n";

/* Me page: the customer's agent with one-tap WhatsApp / call. */
export const MyAgentCard = () => {
  const { lang } = useI18n();
  const ta = lang === "ta";
  const [agent, setAgent] = useState(undefined);
  useEffect(() => { api.get("/auth/my-agent").then((r) => setAgent(r.data.agent)).catch(() => setAgent(null)); }, []);
  if (!agent) return null;
  const digits = (agent.whatsapp || agent.mobile || "").replace(/\D/g, "");
  const wa = digits.length === 10 ? `91${digits}` : digits;
  const text = encodeURIComponent(ta ? `வணக்கம் ${agent.name}, ROYAL LAKSHMI app-ல் உங்கள் customer. Recharge / booking help வேண்டும்.` : `Hi ${agent.name}, I'm your ROYAL LAKSHMI customer. I need help with recharge / booking.`);
  return (
    <div className="rl-card p-4" data-testid="my-agent-card">
      <div className="flex items-center gap-2 mb-2"><UserCheck className="w-4 h-4 text-emerald-600" /><span className="font-semibold text-slate-900">{ta ? "உங்கள் ஏஜென்ட்" : "Your agent"}</span></div>
      <div className="flex items-center justify-between gap-3">
        <div><div className="font-bold text-slate-900" data-testid="my-agent-name">{agent.name}</div><div className="text-xs text-slate-500 font-mono">{agent.mobile}</div><div className="text-[10px] text-slate-400">{ta ? "Recharge · booking help · payout" : "Recharge · booking help · payout"}</div></div>
        <div className="flex gap-2">
          <a href={`https://wa.me/${wa}?text=${text}`} target="_blank" rel="noreferrer" onClick={() => logWa({ target_name: agent.name, target_role: "agent", target_mobile: agent.mobile }, "customer→agent")} className="w-10 h-10 rounded-xl bg-emerald-500 text-white flex items-center justify-center" data-testid="my-agent-whatsapp" aria-label="WhatsApp agent"><MessageCircle className="w-5 h-5" /></a>
          <a href={`tel:+${((agent.mobile || "").replace(/\D/g, "").length === 10 ? "91" : "") + (agent.mobile || "").replace(/\D/g, "")}`} className="w-10 h-10 rounded-xl bg-blue-600 text-white flex items-center justify-center" data-testid="my-agent-call" aria-label="Call agent"><Phone className="w-5 h-5" /></a>
        </div>
      </div>
    </div>
  );
};
